import React from 'react'

function style3() {
    return (
            <svg xmlns="http://www.w3.org/2000/svg" width="86" height="41" viewBox="0 0 86 41">
            <defs>
            </defs>
            <g transform="translate(-201 -633)">
            <g className="a" fill="#fff" stroke="none" strokeMiterlimit="10" transform="translate(201 633)">
            <rect className="c" stroke="none" width="86" height="41" rx="2"/>
            <rect className="d" fill="none" x="0.5" y="0.5" width="85" height="40" rx="1.5"/>
            </g>
            <g className="b" stroke="#acacac" strokeWidth="0.5px" fill="none" transform="translate(211 638)">
            <rect className="c" stroke="none" width="67" height="31"/>
            <rect className="d" fill="none" x="0.25" y="0.25" width="66.5" height="30.5"/>
            </g>
            </g>
            </svg>
    )
}

export default style3
